export default __webpack_public_path__ + "static/media/image31.40877776.jpg";